export const folderClear = 'FOLDER_CLEAR';
export const folderFetch = 'FOLDER_FETCH';
export const folderSelected = 'FOLDER_SELECTED';
export const folderNavigateBack = 'FOLDER_NAVIGATE_BACK';

export default {
    clear: folderClear,
    fetch: folderFetch,
    selected: folderSelected,
    navigateBack: folderNavigateBack
};
